<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <!-- Esta vista es técnica de superadmin: no tiene metadata propia en
             m_modules_permissions, por eso el resumen es hardcodeado. -->
        <section class="list-view-heading">
          <StaticViewHeading icon="admin_panel_settings" subtitle="Configuración de permisos, widgets y parámetros de los módulos activos" />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions :show-shortcut="false" /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': table.mostrarFiltros }"
                        v-b-tooltip.hover.bottom
                        :title="table.mostrarFiltros ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="table.mostrarFiltros ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="table.mostrarFiltros = !table.mostrarFiltros">
                <AppIcon name="filter" :fill="table.mostrarFiltros" />
              </b-button>
            </div>
          </div>
        </section>
        <b-collapse v-model="table.mostrarFiltros">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 190px;">
              <label class="filter-label" for="permissions-support-filter">Vistas</label>
              <b-form-select id="permissions-support-filter" v-model="table.viewSupport" size="sm" :options="viewSupportOptions" />
            </div>
            <div class="list-view-filter" style="width: 190px;">
              <label class="filter-label" for="permissions-mobile-first-filter">Mobile-first</label>
              <b-form-select id="permissions-mobile-first-filter" v-model="table.mobileFirstFilter" size="sm" :options="mobileFirstFilterOptions" />
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card no-body>
        <b-row>
          <b-col>
            <b-table class="app-table permissions-table"
                    responsive="sm"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="filteredModules"
                    :fields="tableFields"
                    :stacked="isMobileViewport ? 'md' : false"
                    selectable
                    select-mode="single"
                    @row-selected="onRowSelected"
                    v-if="filteredModules.length">

                <template v-slot:row-details="row">
                   <b-card no-body>
                    <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-info"
                            content-class="mt-3">

                      <b-tab title="Vistas" active>
                        <b-card-text>
                          <b-tabs pills card :vertical="!isMobileViewport" class="permission-profile-tabs">

                            <b-tab title="Staff" active v-if="isModuleActive('personal')">
                              <b-card-text>

                                <b-list-group>
                                  <b-list-group-item href="#"
                                                    class="flex-column align-items-start"
                                                    :class="{ 'permission-view--deprecated': item.deprecated }"
                                                    v-for="item in filtroPersonal(row.item.modules_permissions)"
                                                    :key="item.id">
                                    <div class="d-flex w-100 justify-content-between">
                                      <h5 class="mb-1">
                                        ID:{{item.id}} - {{item.reference}}
                                      </h5>
                                      <div>
                                        <b-badge variant="info" class="permission-view-mobile-first__badge" v-if="item.mobile_first"><AppIcon name="phone" class="mr-1" />Mobile-first</b-badge>
                                        <b-badge variant="danger" class="permission-view-deprecated__badge" v-if="item.deprecated"><AppIcon name="warning" class="mr-1" />Vista sin soporte</b-badge>
                                        <b-badge variant="success" class="badge-module-permission-init-custom pull-right" v-if="item.init">Pantalla principal</b-badge>
                                      </div>
                                    </div>

                                    <div v-if="item.deprecated" class="permission-view-deprecated__notice">
                                      <AppIcon name="warning" class="mr-1" />Esta vista está discontinuada; se conserva sólo por compatibilidad.
                                    </div>

                                    <small class="text-muted">Roles que pueden visualizar la vista</small>
                                    &nbsp;&nbsp;<b-button variant="outline-info" size="sm" @click="asignarRoles(item, row.index, 'personal')" v-b-tooltip.top title="Click para editar permisos">Permitir Roles</b-button>
                                    <div class="mb-1" v-if="item.roles">
                                      <span class="mr-2"
                                            v-for="value in item.roles.split(',')"
                                            :key="value"
                                            v-html="getNameRoles(value, 'personal')">
                                      </span>
                                    </div>
                                    <div v-else>
                                      <span class='badge badge-danger badge-module-permissions-custom'>No Configurado</span>
                                    </div>

                                    <div class="mb-1" v-if="item.modules_permissions_elements.length">
                                      <small class="text-muted">Esta vista contiene <b>{{item.modules_permissions_elements.length}} elementos</b> a los que se les puede denegar el permisos a los roles que la visualzan.</small>
                                      &nbsp;&nbsp;<b-button variant="outline-danger" size="sm" @click="openDenegarRoles(item, row.index, 'personal')" v-b-tooltip.top title="Click para editar permisos">Denegar Roles</b-button>
                                      <br>
                                      <div v-for="elements in item.modules_permissions_elements" :key="elements.id" class="mb-1">
                                        <span v-if="elements.roles">
                                          <span class="element-text-custom">{{elements.reference}}:</span>&nbsp;&nbsp;
                                          <span class="mb-1" v-for="rolDeny in elements.roles.split(',')" :key="rolDeny">
                                            <span class="mr-2" v-html="getNameRoles(rolDeny, 'personal')"></span>
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </b-list-group-item>

                                  <b-badge v-if="!filtroPersonal(row.item.modules_permissions).length" variant="warning" class="badge-module-permissions-custom p-5">No tiene vistas para este perfil</b-badge>
                                </b-list-group>

                              </b-card-text>
                            </b-tab>

                            <b-tab title="Cliente" v-if="isModuleActive('clientes')">
                              <b-card-text>

                                <b-list-group>
                                  <b-list-group-item href="#"
                                                    class="flex-column align-items-start"
                                                    :class="{ 'permission-view--deprecated': item.deprecated }"
                                                    v-for="item in filtroCliente(row.item.modules_permissions)"
                                                    :key="item.id">
                                    <div class="d-flex w-100 justify-content-between">
                                      <h5 class="mb-1">
                                        ID:{{item.id}} - {{item.reference}}
                                      </h5>
                                      <div>
                                        <b-badge variant="info" class="permission-view-mobile-first__badge" v-if="item.mobile_first"><AppIcon name="phone" class="mr-1" />Mobile-first</b-badge>
                                        <b-badge variant="danger" class="permission-view-deprecated__badge" v-if="item.deprecated"><AppIcon name="warning" class="mr-1" />Vista sin soporte</b-badge>
                                        <b-badge variant="success" class="badge-module-permission-init-custom pull-right" v-if="item.init">Pantalla principal</b-badge>
                                      </div>
                                    </div>
                                    <div v-if="item.deprecated" class="permission-view-deprecated__notice">
                                      <AppIcon name="warning" class="mr-1" />Esta vista está discontinuada; se conserva sólo por compatibilidad.
                                    </div>
                                    <small class="text-muted">Roles que pueden visualizar la vista</small>
                                    &nbsp;&nbsp;<b-button variant="outline-info" size="sm" @click="asignarRoles(item, row.index, 'clientes')" v-b-tooltip.top title="Click para editar permisos">Permitir Roles</b-button>
                                    <div class="mb-1" v-if="item.roles">
                                      <span class="mr-2"
                                            v-for="value in item.roles.split(',')"
                                            :key="value"
                                            v-html="getNameRoles(value, 'clientes')">
                                      </span>
                                    </div>
                                    <div v-else>
                                      <span class='badge badge-danger badge-module-permissions-custom'>No Configurado</span>
                                    </div>

                                    <div class="mb-1" v-if="item.modules_permissions_elements.length">
                                      <small class="text-muted">Esta vista contiene <b>{{item.modules_permissions_elements.length}} elementos</b> a los que se les puede denegar el permisos a los roles que la visualzan.</small>
                                      &nbsp;&nbsp;<b-button variant="outline-danger" size="sm" @click="openDenegarRoles(item, row.index, 'clientes')" v-b-tooltip.top title="Click para editar permisos">Denegar Roles</b-button>
                                      <br>
                                      <div v-for="elements in item.modules_permissions_elements" :key="elements.id" class="mb-1">
                                        <span v-if="elements.roles">
                                          <span class="element-text-custom">{{elements.reference}}:</span>&nbsp;&nbsp;
                                          <span class="mb-1" v-for="rolDeny in elements.roles.split(',')" :key="rolDeny">
                                            <span class="mr-2" v-html="getNameRoles(rolDeny, 'clientes')"></span>
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </b-list-group-item>

                                  <b-badge v-if="!filtroCliente(row.item.modules_permissions).length" variant="warning" class="badge-module-permissions-custom p-5">No tiene vistas para este perfil</b-badge>
                                </b-list-group>

                              </b-card-text>
                            </b-tab>

                            <b-tab title="Proveedor" v-if="isModuleActive('proveedores')">
                              <b-card-text>

                                <b-list-group>
                                  <b-list-group-item href="#"
                                                    class="flex-column align-items-start"
                                                    :class="{ 'permission-view--deprecated': item.deprecated }"
                                                    v-for="item in filtroProveedor(row.item.modules_permissions)"
                                                    :key="item.id">
                                    <div class="d-flex w-100 justify-content-between">
                                      <h5 class="mb-1">
                                        ID:{{item.id}} - {{item.reference}}
                                      </h5>
                                      <div>
                                        <b-badge variant="info" class="permission-view-mobile-first__badge" v-if="item.mobile_first"><AppIcon name="phone" class="mr-1" />Mobile-first</b-badge>
                                        <b-badge variant="danger" class="permission-view-deprecated__badge" v-if="item.deprecated"><AppIcon name="warning" class="mr-1" />Vista sin soporte</b-badge>
                                        <b-badge variant="success" class="badge-module-permission-init-custom pull-right" v-if="item.init">Pantalla principal</b-badge>
                                      </div>
                                    </div>
                                    <div v-if="item.deprecated" class="permission-view-deprecated__notice">
                                      <AppIcon name="warning" class="mr-1" />Esta vista está discontinuada; se conserva sólo por compatibilidad.
                                    </div>
                                    <small class="text-muted">Roles que pueden visualizar la vista</small>
                                    &nbsp;&nbsp;<b-button variant="outline-info" size="sm" @click="asignarRoles(item, row.index, 'proveedores')" v-b-tooltip.top title="Click para editar permisos">Permitir Roles</b-button>
                                    <div class="mb-1" v-if="item.roles">
                                      <span class="mr-2"
                                            v-for="value in item.roles.split(',')"
                                            :key="value"
                                            v-html="getNameRoles(value, 'proveedores')">
                                      </span>
                                    </div>
                                    <div v-else>
                                      <span class='badge badge-danger badge-module-permissions-custom'>No Configurado</span>
                                    </div>

                                    <div class="mb-1" v-if="item.modules_permissions_elements.length">
                                      <small class="text-muted">Esta vista contiene <b>{{item.modules_permissions_elements.length}} elementos</b> a los que se les puede denegar el permisos a los roles que la visualzan.</small>
                                      &nbsp;&nbsp;<b-button variant="outline-danger" size="sm" @click="openDenegarRoles(item, row.index, 'proveedores')" v-b-tooltip.top title="Click para editar permisos">Denegar Roles</b-button>
                                      <br>
                                      <div v-for="elements in item.modules_permissions_elements" :key="elements.id" class="mb-1">
                                        <span v-if="elements.roles">
                                          <span class="element-text-custom">{{elements.reference}}:</span>&nbsp;&nbsp;
                                          <span class="mb-1" v-for="rolDeny in elements.roles.split(',')" :key="rolDeny">
                                            <span class="mr-2" v-html="getNameRoles(rolDeny, 'proveedores')"></span>
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </b-list-group-item>

                                  <b-badge v-if="!filtroProveedor(row.item.modules_permissions).length" variant="warning" class="badge-module-permissions-custom p-5">No tiene vistas para este perfil</b-badge>
                                </b-list-group>

                              </b-card-text>
                            </b-tab>

                          </b-tabs>
                        </b-card-text>
                      </b-tab>

                      <b-tab title="Widgets" v-if="row.item.modules_widget.length">
                        <b-tabs pills card :vertical="!isMobileViewport" class="permission-profile-tabs">
                          <b-tab title="Staff" active v-if="isModuleActive('personal')">
                            <b-card-text>
                              <b-list-group>
                                <b-list-group-item href="#"
                                                  class="flex-column align-items-start"
                                                  v-for="item in filtroPersonal(row.item.modules_widget)"
                                                  :key="item.id">

                                  <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">
                                      ID:{{item.id}} -  {{item.title.toUpperCase()}}&nbsp;&nbsp;
                                      <small>{{item.description}}</small>
                                    </h5>
                                    <b-badge variant="success" class="badge-module-permission-init-custom pull-right">{{item.type}}</b-badge>
                                  </div>

                                  <small class="text-muted">Roles que NO pueden visualizar este widget</small>
                                  &nbsp;&nbsp;<b-button variant="outline-danger" size="sm" @click="denegarRolesWidget(item, row.index, 'personal')" v-b-tooltip.top title="Click para editar permisos">Denegar Roles</b-button>
                                  <div class="mb-1" v-if="item.roles">
                                    <span class="mr-2"
                                          v-for="value in item.roles.split(',')"
                                          :key="value"
                                          v-html="getNameRoles(value, 'personal')">
                                    </span>
                                  </div>
                                  <div v-else>
                                    <span class='badge badge-danger badge-module-permissions-custom'>No Configurado</span>
                                  </div>
                                </b-list-group-item>

                                <b-badge v-if="!filtroPersonal(row.item.modules_widget).length" variant="warning" class="badge-module-permissions-custom p-5">No tiene widgets para este perfil</b-badge>
                              </b-list-group>
                            </b-card-text>
                          </b-tab>
                          <b-tab title="Cliente" v-if="isModuleActive('clientes')">
                            <b-card-text>
                              <b-list-group>
                                <b-list-group-item href="#"
                                                  class="flex-column align-items-start"
                                                  v-for="item in filtroCliente(row.item.modules_widget)"
                                                  :key="item.id">

                                  <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">
                                      ID:{{item.id}} -  {{item.title.toUpperCase()}}&nbsp;&nbsp;
                                      <small>{{item.description}}</small>
                                    </h5>
                                    <b-badge variant="success" class="badge-module-permission-init-custom pull-right">{{item.type}}</b-badge>
                                  </div>

                                  <small class="text-muted">Roles que NO pueden visualizar este widget</small>
                                  &nbsp;&nbsp;<b-button variant="outline-danger" size="sm" @click="denegarRolesWidget(item, row.index, 'clientes')" v-b-tooltip.top title="Click para editar permisos">Denegar Roles</b-button>
                                  <div class="mb-1" v-if="item.roles">
                                    <span class="mr-2"
                                          v-for="value in item.roles.split(',')"
                                          :key="value"
                                          v-html="getNameRoles(value, 'clientes')">
                                    </span>
                                  </div>
                                  <div v-else>
                                    <span class='badge badge-danger badge-module-permissions-custom'>No Configurado</span>
                                  </div>
                                </b-list-group-item>

                                <b-badge v-if="!filtroCliente(row.item.modules_widget).length" variant="warning" class="badge-module-permissions-custom p-5">No tiene widgets para este perfil</b-badge>
                              </b-list-group>
                            </b-card-text>
                          </b-tab>
                          <b-tab title="Proveedor" v-if="isModuleActive('proveedores')">
                            <b-card-text>
                              <b-list-group>
                                <b-list-group-item href="#"
                                                  class="flex-column align-items-start"
                                                  v-for="item in filtroProveedor(row.item.modules_widget)"
                                                  :key="item.id">

                                  <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">
                                      ID:{{item.id}} -  {{item.title.toUpperCase()}}&nbsp;&nbsp;
                                      <small>{{item.description}}</small>
                                    </h5>
                                    <b-badge variant="success" class="badge-module-permission-init-custom pull-right">{{item.type}}</b-badge>
                                  </div>

                                  <small class="text-muted">Roles que NO pueden visualizar este widget</small>
                                  &nbsp;&nbsp;<b-button variant="outline-danger" size="sm" @click="denegarRolesWidget(item, row.index, 'proveedores')" v-b-tooltip.top title="Click para editar permisos">Denegar Roles</b-button>
                                  <div class="mb-1" v-if="item.roles">
                                    <span class="mr-2"
                                          v-for="value in item.roles.split(',')"
                                          :key="value"
                                          v-html="getNameRoles(value, 'proveedores')">
                                    </span>
                                  </div>
                                  <div v-else>
                                    <span class='badge badge-danger badge-module-permissions-custom'>No Configurado</span>
                                  </div>
                                </b-list-group-item>

                                <b-badge v-if="!filtroProveedor(row.item.modules_widget).length" variant="warning" class="badge-module-permissions-custom p-5">No tiene widgets para este perfil</b-badge>
                              </b-list-group>
                            </b-card-text>
                          </b-tab>
                        </b-tabs>
                      </b-tab>

                      <b-tab title="Parametros" v-if="row.item.modules_parameters.length">
                        <b-card-text>
                          <b-table class="app-table app-table--compact"
                            responsive="sm"
                            :stacked="isMobileViewport ? 'md' : false"
                            :hover="true"
                            :small="true"
                            :fixed="false"
                            :items="tableParameters.items"
                            :fields="tableParametersFields"
                            v-if="tableParameters.items.length">

                            <template v-slot:cell(value)="data">
                              <b-badge variant="success" class="badge-module-permissions-custom" v-if="data.item.value">Activado</b-badge>
                              <b-badge variant="danger" class="badge-module-permissions-custom" v-else>Inactivo</b-badge>
                            </template>

                            <template v-slot:cell(f_action)="data">
                              <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle">
                                <template #button-content><AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" /><span v-if="isMobileViewport" class="app-table-action-label">Opciones</span></template>
                                <b-dropdown-item @click="configurateParametrsConfirm(data.item)" v-if="!data.item.value">
                                  <AppIcon name="check" class="text-success mr-1" /> Activar
                                </b-dropdown-item>
                                <b-dropdown-item @click="configurateParametrsConfirm(data.item)" v-if="data.item.value">
                                  <AppIcon name="block" class="text-danger mr-1" /> Desactivar
                                </b-dropdown-item>
                              </b-dropdown>
                            </template>
                          </b-table>
                          <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>

                        </b-card-text>
                      </b-tab>

                    </b-tabs>
                  </b-card>
                </template>

                <template v-slot:cell(name)="data">
                    <span :class="{ 'text-danger': data.item.deprecated }">{{data.item.name.toUpperCase()}}</span>
                    <b-badge v-if="data.item.deprecated" variant="danger" class="ml-1" v-b-tooltip.hover title="Este módulo está discontinuado, ya no tiene soporte">
                      <AppIcon name="warning" class="mr-1" />Sin soporte
                    </b-badge>
                </template>

                <template v-slot:cell(description)="data">
                    <b>{{data.item.title.substring(data.item.title.indexOf(".") + 1)}}</b><br>
                    {{data.item.description}}
                </template>

                <template v-slot:cell(supported_views)="data">
                  <b-badge variant="success">{{ countViews(data.item, false) }}</b-badge>
                </template>

                <template v-slot:cell(deprecated_views)="data">
                  <b-badge v-if="countViews(data.item, true)" variant="danger">{{ countViews(data.item, true) }}</b-badge>
                  <span v-else class="text-muted">—</span>
                </template>

                <template v-slot:cell(f_action)="row">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle">
                    <template #button-content><AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" /><span v-if="isMobileViewport" class="app-table-action-label">Opciones</span></template>
                    <b-dropdown-item @click="openDetail(row.index)">
                      <AppIcon name="settings" class="text-primary mr-1" /> Configurar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>

            </b-table>
            <EmptyState v-else icon="admin_panel_settings" title="No se encontraron módulos" description="No hay módulos con vistas que coincidan con el filtro seleccionado." />
          </b-col>
        </b-row>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- PERMITIR -->
      <b-modal v-model="modal.form.active">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="groups" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>
        <b-row>
          <b-col>
            <b-form-group label="Roles">
              <b-form-select v-model="crud.form.roles" :options="arr.roles" multiple :select-size="4"></b-form-select>
              <b-button type="button" variant="link" class="list-view-ghost-btn mt-1" @click="crud.form.roles=[]">
                <AppIcon name="refresh" class="mr-1" />Borrar selección
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">                  
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="configurate(modal.form.type)"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

      <!-- DENEGAR -->
      <b-modal v-model="modal.formDeny.active"
               no-close-on-esc
               no-close-on-backdrop
               hide-header-close>

        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="block" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formDeny.title}}</h5>
        </div>
        <b-row>
          <b-col>

            <div role="tablist">
              <b-card no-body class="mb-1" v-for="(item, index) in arr.element" :key="item.id">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle="'accordion-' + index" variant="secondary" class="text-left">
                    <b>Elemento:</b> {{item.reference}}
                  </b-button>
                </b-card-header>
                <b-collapse :id="'accordion-'+ index" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-alert variant="danger" :show="!arr.rolesDeny.length">
                      No se encontraron roles para denegar. <br>Primero asigne roles a la vista
                    </b-alert>
                    <b-form-group label="Roles" v-if="arr.rolesDeny.length">
                      <b-form-select v-model="item.roles" :options="arr.rolesDeny" multiple :select-size="4"></b-form-select>
                      <b-button type="button" variant="link" class="list-view-ghost-btn mt-1" @click="item.roles=[]">
                        <AppIcon name="refresh" class="mr-1" />Borrar selección
                      </b-button>
                    </b-form-group>
                    <b-form-group>
                      <button type="button" class="btn btn-dark pull-right" v-if="arr.rolesDeny.length" @click="guardarRolesDeny(item)">
                        <AppIcon name="save" class="mr-1" />Guardar
                      </button>
                    </b-form-group>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

          </b-col>
        </b-row>
        <template v-slot:modal-footer>
          <b-button type="button" variant="outline-secondary" @click="finishDenyRoles()"><AppIcon name="done" class="mr-1" />Terminar</b-button>
        </template>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import StaticViewHeading from '@/components/inc/module/StaticViewHeading'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: { StaticViewHeading, TabHeaderActions },
    data: () => {
      return {
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID'},
            {key: 'name', label: 'Módulo',},
            {key: 'description', label: 'Descripción'},
            {key: 'supported_views', label: 'Vistas con soporte'},
            {key: 'deprecated_views', label: 'Vistas sin soporte'},
            {key: 'f_action', label: ''},
          ],
          rowSelected: null,
          mostrarFiltros: false,
          viewSupport: 'supported',
          mobileFirstFilter: 'all'
        },
        tableParameters : {
          items: [],
          fields: [
            {key: 'id', label: 'ID'},
            {key: 'description', label: 'Descripción'},
            {key: 'value', label: 'Activado'},
            {key: 'f_action', label: ''},
          ],
        },
        isMobileViewport: false,
        modal: {
          form: {
            active: false,
            title: '',
            type: '',
          },
          formDeny: {
            active: false,
            title: '',
          }
        },
        crud: {
          form: {
            id: 0,
            module_id: 0,
            reference: '',
            roles: []
          }
        },
        arr: {
          roles: [],
          rolesPersonal: [],
          rolesClientes: [],
          rolesProveedores: [],
          modules: [],
          element: [],
          rolesDeny: [],
        }
      }
    },
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.cargar()
      this.cargarRoles()
    },
    beforeDestroy() {
      if (this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    computed: {
      tableFields () {
        return this.table.fields.map(field => field.key === 'f_action' ? Object.assign({}, field, { label: this.isMobileViewport ? 'Acción' : '', thClass: 'align-middle' }) : field)
      },
      tableParametersFields () {
        return this.tableParameters.fields.map(field => field.key === 'f_action' ? Object.assign({}, field, { label: this.isMobileViewport ? 'Acción' : '', thClass: 'align-middle' }) : field)
      },
      viewSupportOptions () {
        return [
          { value: 'supported', text: 'Con soporte' },
          { value: 'deprecated', text: 'Sin soporte' },
          { value: 'all', text: 'Todas las vistas' },
        ]
      },
      mobileFirstFilterOptions () {
        return [
          { value: 'all', text: 'Todas las con soporte' },
          { value: 'mobileFirst', text: 'Solo mobile-first' },
        ]
      },
      filteredModules () {
        return this.table.items.filter(module => {
          const views = module.modules_permissions || []
          return views.some(view => this.matchesViewFilters(view))
        })
      },
    },
    methods: {
      updateMobileViewport (event) {
        this.isMobileViewport = event.matches
      },
      cargar () {
        let loader = this.$loading.show();
        var result = serviceAPI.obtener()

        result.then((response) => {
          var data = response.data
          this.table.items = data
          this.arr.modules = data

          if(this.table.rowSelected!=null) {
            this.table.items[this.table.rowSelected]._showDetails = true
            this.tableParameters.items = this.table.items[this.table.rowSelected].modules_parameters
          }
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      onRowSelected(item) {
        this.arr.modules.forEach((element, index) => {
          if(item.length){
            if(element.id == item[0].id) {
              this.openDetail(index)
            }
          }
        })
      },
      openDetail(index) {
        this.table.rowSelected = index
        this.cargar()
      },
      isModuleActive(value) {
        var status = false
        this.arr.modules.forEach(element=>{
          if(element.name==value) {
            status = true
          }
        })
        return status
      },
      filtroPersonal(row) {
        return this.filterViews(row, Profiles.PERSONAL)
      },
      filtroCliente(row) {
        return this.filterViews(row, Profiles.CLIENTE)
      },
      filtroProveedor(row) {
        return this.filterViews(row, Profiles.PROVEEDOR)
      },
      matchesViewFilters(view) {
        if (this.table.viewSupport === 'supported' && view.deprecated) return false
        if (this.table.viewSupport === 'deprecated' && !view.deprecated) return false
        if (this.table.mobileFirstFilter === 'mobileFirst' && !view.mobile_first) return false
        return true
      },
      filterViews(row, profileId) {
        return row.filter(element => element.profile_id == profileId && this.matchesViewFilters(element))
      },
      countViews (module, deprecated) {
        if (this.table.viewSupport === 'supported' && deprecated) return 0
        if (this.table.viewSupport === 'deprecated' && !deprecated) return 0
        return (module.modules_permissions || []).filter(view => {
          if (Boolean(view.deprecated) !== deprecated) return false
          if (this.table.mobileFirstFilter === 'mobileFirst' && !view.mobile_first) return false
          return true
        }).length
      },
      cargarRoles () {
        var result = serviceAPI.obtenerRoles()

        result.then((response) => {
          var data = response.data

          data.forEach(element => {
            if( element.profile_id == Profiles.PERSONAL ) {
              this.arr.rolesPersonal.push({ value: element.id, text: element.name })
            }
            if( element.profile_id == Profiles.CLIENTE ) {
              this.arr.rolesClientes.push({ value: element.id, text: element.name })
            }
            if( element.profile_id == Profiles.PROVEEDOR ) {
              this.arr.rolesProveedores.push({ value: element.id, text: element.name })
            }
          })
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });
      },
      getNameRoles(item, tipo) {
        var name = ''

        if(tipo == "personal") {
          this.arr.rolesPersonal.forEach(element => {
            if(element.value == item) {
              name = element.text
            }
          });
        }
        if(tipo == "clientes") {
          this.arr.rolesClientes.forEach(element => {
            if(element.value == item) {
              name = element.text
            }
          });
        }
        if(tipo == "proveedores") {
          this.arr.rolesProveedores.forEach(element => {
            if(element.value == item) {
              name = element.text
            }
          });
        }

        if(name) {
          return "<span class='badge badge-secondary badge-module-permissions-custom'>" + name + "</span>"
        } else {
          return ""
        }
      },
      asignarRoles(item, row, tipo) {

        if(tipo == "personal") {
          this.arr.roles = this.arr.rolesPersonal
        }
        if(tipo == "clientes") {
          this.arr.roles = this.arr.rolesClientes
        }
        if(tipo == "proveedores") {
          this.arr.roles = this.arr.rolesProveedores
        }

        this.modal.form.active = true
        this.modal.form.title = "Asignación de Permisos --> Vista - " + item.reference.toUpperCase()
        this.modal.form.type = "vista"

        this.crud.form.id = item.id
        this.crud.form.module_id = item.module_id
        this.crud.form.reference = item.reference
        if(item.roles) {
          this.crud.form.roles = item.roles.split(',')
        } else {
          this.crud.form.roles = []
        }

        this.table.rowSelected = row
      },
      denegarRolesWidget(item, row, tipo) {

        if(tipo == "personal") {
          this.arr.roles = this.arr.rolesPersonal
        }
        if(tipo == "clientes") {
          this.arr.roles = this.arr.rolesClientes
        }
        if(tipo == "proveedores") {
          this.arr.roles = this.arr.rolesProveedores
        }

        this.modal.form.active = true
        this.modal.form.title = "Denegar Permisos --> Widget - " + item.title.toUpperCase()
        this.modal.form.type = "widget"

        this.crud.form.id = item.id
        this.crud.form.module_id = item.module_id
        this.crud.form.reference = item.reference
        if(item.roles) {
          this.crud.form.roles = item.roles.split(',')
        } else {
          this.crud.form.roles = []
        }

        this.table.rowSelected = row
      },
      configurate(type) {
        let loader = this.$loading.show();

        let result
        if(type=="vista") {
          result = serviceAPI.configurar(this.crud.form);
        } else {
          if(type=="widget") {
            result = serviceAPI.configurarWidget(this.crud.form);
          }
        }

        result.then(() => {
          this.modal.form.active = false
          loader.hide()
          this.cargar()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      openDenegarRoles(item, row, tipo) {
        this.modal.formDeny.active = true
        this.modal.formDeny.title = "Denegar permisos --> Elementos de - " + item.reference.toUpperCase()

        if(tipo == "personal") {
          this.arr.rolesPersonal.forEach(element1 => {
            if(!item.roles) {
              item.roles = ''
            }
            item.roles.split(',').forEach(element2 => {
              if(element1.value == element2) {
                this.arr.rolesDeny.push({ value: element1.value, text: element1.text })
              }
            })
          })
        }
        if(tipo == "clientes") {
          this.arr.rolesClientes.forEach(element1 => {
            if(!item.roles) {
              item.roles = ''
            }
            item.roles.split(',').forEach(element2 => {
              if(element1.value == element2) {
                this.arr.rolesDeny.push({ value: element1.value, text: element1.text })
              }
            })
          })
        }
        if(tipo == "proveedores") {
          this.arr.rolesProveedores.forEach(element1 => {
            if(!item.roles) {
              item.roles = ''
            }
            item.roles.split(',').forEach(element2 => {
              if(element1.value == element2) {
                this.arr.rolesDeny.push({ value: element1.value, text: element1.text })
              }
            })
          })
        }

        item.modules_permissions_elements.forEach(element => {
          var rolElement = []
          if(element.roles) {
            rolElement = element.roles.split(',')
          }

          this.arr.element.push({
            id: element.id,
            reference: element.reference,
            roles: rolElement
          })
        })
      },
      guardarRolesDeny(item) {
        let loader = this.$loading.show();
        var data = { id: item.id, roles: item.roles}
        var result = serviceAPI.configurarRoleDeny(data);

        result.then(() => {
          loader.hide()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      finishDenyRoles() {
        this.modal.formDeny.active = false
        this.modal.formDeny.title = ""

        this.arr.element = []
        this.arr.rolesDeny = []

        this.cargar()
      },
      configurateParametrsConfirm(item) {
        this.$bvModal.msgBoxConfirm('¿Desea cambiar el estado de este registro ID >> ' + item.id + '?', {
          title: 'Borrar Usuario',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            this.configurateParametrs(item)
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      configurateParametrs(item) {
        let loader = this.$loading.show();

        var data ={ id: item.id, value: !item.value}
        var result = serviceAPI.configurarParametro(data);

        result.then(() => {
          var result1 = serviceAPI.obtenerParametros()

          result1.then((response1) => {
            var data = response1.data

            Session.setSessionParameters(data);
            loader.hide()
            this.cargar()
            this.$awn.success("Parametro configurado con éxito");
          })
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      }
    }
  }
</script>
<style>
  .badge-module-permissions-custom {
    font-size: 14px;
  }
  .badge-module-permission-init-custom {
    padding: 6px;
  }
  .element-text-custom {
    font-weight: 500
  }
  .permission-view--deprecated {
    background: var(--app-color-danger-soft) !important;
    border-left: 4px solid var(--app-color-danger) !important;
  }
  .permission-view--deprecated h5 {
    color: var(--app-color-danger-hover);
  }
  .permission-view-deprecated__badge {
    font-size: 12px;
    padding: 6px 8px;
  }
  .permission-view-mobile-first__badge {
    font-size: 12px;
    padding: 6px 8px;
    margin-right: 4px;
    transition: background-color .15s ease;
  }
  .permission-view-mobile-first__badge:hover {
    background-color: var(--app-color-primary-hover) !important;
  }
  .permission-view-deprecated__notice {
    align-items: center;
    color: var(--app-color-danger-hover);
    display: flex;
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
    margin: 2px 0 8px;
  }
  /* Cada vista es un b-list-group-item con href="#" (así BootstrapVue le
     agrega los botones "Permitir/Denegar Roles" dentro), así que Bootstrap
     le pone hover/active de acción: hover gris, pero el estado "clickeado"
     (.active/:active) queda con fondo sólido $primary (mismo color que el
     botón outline-info "Permitir Roles" y el badge Mobile-first) — todo el
     texto y los botones dentro de la fila quedaban ilegibles contra ese
     mismo azul. Antes esto solo se resolvía en mobile (ver el bloque
     @media de acá abajo); se generaliza para que tampoco pase en desktop. */
  .permission-profile-tabs .list-group-item:hover,
  .permission-profile-tabs .list-group-item:focus {
    background-color: var(--app-color-primary-soft) !important;
    color: var(--app-color-text) !important;
  }
  .permission-profile-tabs .list-group-item.active,
  .permission-profile-tabs .list-group-item:active {
    background-color: var(--app-color-surface) !important;
    color: var(--app-color-text) !important;
  }
  @media (max-width: 767.98px) {
    .permissions-table.b-table-stacked-md > tbody > tr > td::before {
      min-height: 30px;
    }
    .permission-profile-tabs.card {
      border: 0;
      box-shadow: none;
    }
    .permission-profile-tabs > .card-header {
      background: transparent;
      border: 0;
      padding: 0 0 10px;
    }
    .permission-profile-tabs .nav-pills {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
    }
    .permission-profile-tabs .nav-pills .nav-link {
      background: var(--app-color-surface-subtle);
      border: 1px solid var(--app-color-border);
      border-radius: 6px;
      color: var(--app-color-text-secondary);
      padding: 6px 12px;
    }
    .permission-profile-tabs .nav-pills .nav-link.active {
      background: var(--app-color-primary);
      border-color: var(--app-color-primary);
      color: #fff;
    }
    .permission-profile-tabs > .tab-content {
      border: 1px solid var(--app-color-border);
      border-radius: 8px;
      padding: 10px;
    }
    .permission-profile-tabs .list-group-item {
      background: var(--app-color-surface);
      border-color: var(--app-color-border);
      color: var(--app-color-text);
    }
    .permission-profile-tabs .list-group-item.active,
    .permission-profile-tabs .list-group-item:active {
      background: var(--app-color-surface);
      color: var(--app-color-text);
    }
  }
</style>
